import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问答</h2>
          <p className="mt-2 text-sm text-foreground-600">关于黑料官网的常见问题与解答</p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-4">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-6"
            >
              <h3 className="text-base font-semibold text-foreground-900 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-sm font-bold text-primary-500 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {faq.question}
              </h3>
              <p className="mt-3 pl-9 text-sm text-foreground-700 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}